module.exports = __webpack_public_path__ + "img/620931b.png";